import { GetterTree } from 'vuex'
import { UserState } from './user.types'
import get from 'lodash/get'
import { TechpackSection, TechpackSubsection, UserRole } from '../../types'

export const getters: GetterTree<UserState, unknown> = {
  user(state) {
    return state.user
  },
  loading(state) {
    return state.loading
  },
  showDenseRows(state) {
    return !!get(state, 'user.show_dense_item_view')
  },
  userName(state) {
    return `${state.user?.first_name} ${state.user?.last_name}`
  },
  userError(state) {
    return state.userError
  },
  isCompanyMultiBrand(state) {
    return state.user?.company?.type?.includes('Multi Brand')
  },
  userIsReadOnly(state) {
    return state.user?.role === UserRole.READONLY
  },
  techpackImageSections(state: UserState): TechpackSubsection[] {
    if (!state.user?.company?.techpack_sections) return []
    const techpackSections = state.user.company.techpack_sections.find((s: TechpackSection) => s.name === 'images')
    if (!techpackSections || !techpackSections.subsections) return []
    const subsections = techpackSections.subsections.filter(
      (s: TechpackSubsection) => s.name !== 'uncategorized' && s.name !== 'Color Variants' && s.name !== 'colorways'
    )
    subsections.unshift({
      display_name: 'Uncategorized',
      name: 'uncategorized',
      section_id: '0',
      tag: 'image'
    })
    return subsections
  }
}
